// Components==============
import { useState } from 'react';
// =========================

export function useHomeworkNavigation(
    userAnswers: any[],
    canAlwaysGoNext = false
) {
    const [current, setCurrent] = useState<number>(0);

    const canGoToNext = canAlwaysGoNext
        ? true
        : current <= userAnswers.length - 1;
    const next = !canGoToNext
        ? undefined
        : () => setCurrent((prev) => prev + 1);

    return { next, current, setCurrent };
}
